import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_COL_REG_002_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [gridApiRefH.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_SAL_COL_REG_002_POP_001", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_sal_col_reg_002_pop_01",
            params: searchRef.current.getFormdata(),
          };

          console.log(searchRef.current.getFormdata());
          setDataSource1([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);

          if (data[0] && data[0].length > 0) {
            // 1. 그리드 데이터가 바인딩되었음을 기다림
            await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

            // 2. 첫 번째 행 선택 및 포커스 설정
            gridApiRefH.current.selectAndFocusRow(0);
          }

          gridApiRefH.current.resetUpdate();
        } catch (error) {
          console.log(error);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method

    //#endregion

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>

        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{
              width: 80,
              marginTop: 1.5,
            }}
            spinner={true}
          />
        </div>
        <div>
          <div style={{ height: "55vh", marginTop: "12px" }}>
            <SnGrid
              ref={gridApiRefH} // Grid Name
              columnConfig={columns1} // 컬럼 설정 전달
              rowData={dataSource1} // DataSource
              rowSelection="single" // 행 선택 모드(단일)
              isEditable={false} // 수정 가능 여부
              enableAddRow={false} // 행 추가 여부
              ischeckboxSelection={true} // 체크박스 유무
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_SAL_COL_REG_002_POP_001;
